
export class MobileWallet {
  firstName :	string;
  lastName :	string;
  phoneNumber :	string;
  qrCode : string;
  walletProvider :	string;
  walletUrl :	string;
}
